// State selectors
import { getElementId } from '../selectors/elementSelector';

// Moved to separate file to fix failing test (I assume due to circular dependency)
export default (state, props) => state.getIn(['app', 'attachments', getElementId(state, props)]);
